const addToCartCompleteIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0,0,256,256"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="none" stroke-linecap="none" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(2,2)"><path d="M64,16c-26.50967,0 -48,21.49033 -48,48c0,26.50967 21.49033,48 48,48c26.50967,0 48,-21.49033 48,-48c0,-26.50967 -21.49033,-48 -48,-48z" fill="#ffffff" stroke="none" stroke-width="1" stroke-linecap="butt"></path><path d="M64,25c-21.53911,0 -39,17.46089 -39,39c0,21.53911 17.46089,39 39,39c21.53911,0 39,-17.46089 39,-39c0,-21.53911 -17.46089,-39 -39,-39z" fill="#cd3636" stroke="none" stroke-width="1" stroke-linecap="butt"></path><path d="M64,16c-26.50967,0 -48,21.49033 -48,48c0,26.50967 21.49033,48 48,48c26.50967,0 48,-21.49033 48,-48c0,-26.50967 -21.49033,-48 -48,-48z" fill="none" stroke="#cd3636" stroke-width="6" stroke-linecap="butt"></path><path d="M42,69l13.55,12l30.45,-35" fill="none" stroke="#ffffff" stroke-width="6" stroke-linecap="round"></path></g></g></svg>',
  addToCartIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0,0,256,256"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="none" stroke-linecap="none" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(2,2)"><path d="M64,16c-26.50967,0 -48,21.49033 -48,48c0,26.50967 21.49033,48 48,48c26.50967,0 48,-21.49033 48,-48c0,-26.50967 -21.49033,-48 -48,-48z" fill="#ffffff" stroke="none" stroke-width="1" stroke-linecap="butt"></path><path d="M64,25c-21.53911,0 -39,17.46089 -39,39c0,21.53911 17.46089,39 39,39c21.53911,0 39,-17.46089 39,-39c0,-21.53911 -17.46089,-39 -39,-39z" fill="#cd3636" stroke="none" stroke-width="1" stroke-linecap="butt"></path><path d="M64,16c-26.50967,0 -48,21.49033 -48,48c0,26.50967 21.49033,48 48,48c26.50967,0 48,-21.49033 48,-48c0,-26.50967 -21.49033,-48 -48,-48z" fill="none" stroke="#cd3636" stroke-width="6" stroke-linecap="butt"></path><path d="M64,42v44M42,64h44" fill="none" stroke="#ffffff" stroke-width="6" stroke-linecap="round"></path></g></g></svg>',
  loadingSpinner =
    '<svg width="24" height="24" stroke="#000" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><style>.spinner_V8m1{transform-origin:center;animation:spinner_zKoa 2s linear infinite}.spinner_V8m1 circle{stroke-linecap:round;animation:spinner_YpZS 1.5s ease-in-out infinite}@keyframes spinner_zKoa{100%{transform:rotate(360deg)}}@keyframes spinner_YpZS{0%{stroke-dasharray:0 150;stroke-dashoffset:0}47.5%{stroke-dasharray:42 150;stroke-dashoffset:-16}95%,100%{stroke-dasharray:42 150;stroke-dashoffset:-59}}</style><g class="spinner_V8m1"><circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3"></circle></g></svg>';
var openDrawer = () => {
    document.querySelector("#cartDrawerContainer").classList.add("active");
  },
  updateCartDrawer = (e) => {
    let t = document.querySelector("#CartDrawer"),
      r = new DOMParser()
        .parseFromString(e["cart-drawer"], "text/html")
        .querySelector("#CartDrawer").innerHTML;
    t.innerHTML = r;
    let n = document.querySelector("#cart-icon-bubble");
    n.innerHTML = e["cart-icon-bubble"];
  };
async function cartUpsellCompare(e) {
  let t = $(".cartUpsellProducts"),
    r = [];
  for (let n of t) r.push(n.id);
  let o;
  for (let a = 0; a <= e.items.length - 1; a++)
    (o = r.includes(e.items[a].handle)) && $(`#${e.items[a].handle}`).remove();
}
window.onload = () => {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success(e) {
      cartUpsellCompare(e);
    },
  });
};
const setRemoveEvents = (e) => {
  let t = document.querySelector(
    `.dynamic-remove__button[aria-product-vid='${e}']`
  );
  t.addEventListener("click", (e) => {
    let r = t.getAttribute("aria-product-vid"),
      n = t.getAttribute("aria-product-handle");
    document.querySelectorAll("." + n).forEach((e) => e.remove());
    let o = document.querySelectorAll(".aca-cco");
    for (let a of o) {
      let s = parseInt(a.getAttribute("aca-line"));
      s--, a.setAttribute("aca-line", s.toString());
    }
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      dataType: "json",
      data: { updates: { [r]: 0 }, sections: "cart-drawer,cart-icon-bubble" },
      success(e) {
        updateCartDrawer(e.sections), openDrawer();
      },
    });
  });
};
for (let buyNowButton of $(".buy-now__button"))
  buyNowButton.addEventListener("click", (e) => {
    const quantity = document.querySelector(".custom-quantity__input").value;
    (e.target.innerHTML = "adding..."),
      setTimeout(() => {
        (window.location.href =
          "https://bravebooks.us/cart/" +
          e.target.getAttribute("aria-buy-now") +
          ":" + quantity),
          (e.target.innerHTML = "Buy now");
      }, 1e3);
  });
dynamicAtcAndUpdate = (e) => {
  let t = e,
    r = !1;
  ((t.innerHTML = "Adding..."), (r = !0));
  let n = {
      items: [{ id: t.getAttribute("aria-product-vid"), quantity: 1 }],
      sections: "cart-drawer,cart-icon-bubble",
    },
    o = t.getAttribute("aria-product-sku");
  o &&
    (n.items[0].properties = {
      _upsell_tagging: `Cart Drawer Upsell (${o}`,
    }),
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: n,
      success(e) {
        setTimeout(() => {
          r && (t.innerHTML = "Added!"),
            updateCartDrawer(e.sections),
            openDrawer(),
            $.ajax({
              type: "GET",
              url: "/cart.js",
              dataType: "json",
              success(e) {
                cartUpsellCompare(e);
              },
            });
        }, 500);
      },
      error(e) {
        console.log(e),
          setTimeout(() => {
            t.innerHTML =
              '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0,0,256,256"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="none" stroke-linecap="none" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(2,2)"><path d="M64,16c-26.50967,0 -48,21.49033 -48,48c0,26.50967 21.49033,48 48,48c26.50967,0 48,-21.49033 48,-48c0,-26.50967 -21.49033,-48 -48,-48z" fill="#ffffff" stroke="none" stroke-width="1" stroke-linecap="butt"></path><path d="M64,25c-21.53911,0 -39,17.46089 -39,39c0,21.53911 17.46089,39 39,39c21.53911,0 39,-17.46089 39,-39c0,-21.53911 -17.46089,-39 -39,-39z" fill="#cd3636" stroke="none" stroke-width="1" stroke-linecap="butt"></path><path d="M64,16c-26.50967,0 -48,21.49033 -48,48c0,26.50967 21.49033,48 48,48c26.50967,0 48,-21.49033 48,-48c0,-26.50967 -21.49033,-48 -48,-48z" fill="none" stroke="#cd3636" stroke-width="6" stroke-linecap="butt"></path><path d="M64,42v44M42,64h44" fill="none" stroke="#ffffff" stroke-width="6" stroke-linecap="round"></path></g></g></svg>';
          }, 1e3);
      },
    });
};
